export const getVPSPrices =
  (vpsProductId) =>
  async (dispatch, getState, { api }) =>
    api.getVPSPrices(vpsProductId).then(
      ({ result }) => result,
      (err) => {
        console.error("Get VPS prices request failed", err);
      },
    );
